import clsx from 'clsx';
import { observer } from 'mobx-react-lite';
import { PropsWithChildren } from 'react';

import styles from './Layout.module.scss';

export const Layout = observer<PropsWithChildren>(({ children }) => (
  <div className={clsx(styles.layout, 'in-col')}>{children}</div>
));
